exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".instagram-modal{outline:none}.instagram-modal__wrapper{margin:30px auto;outline:none}.instagram-modal__content{max-height:calc(100vh - 110px);overflow:scroll;padding:10px}@media (max-width: 639px){.instagram-modal__content{padding-bottom:50px}}.instagram-modal__close{display:flex;justify-content:flex-end}@media (min-width: 641px){.instagram-modal__close{left:12px;position:relative}}.instagram-modal__close svg{color:#fff}\n", ""]);

// exports
exports.locals = {
	"instagram-modal": "instagram-modal",
	"instagram-modal__wrapper": "instagram-modal__wrapper",
	"instagram-modal__content": "instagram-modal__content",
	"instagram-modal__close": "instagram-modal__close"
};